import { render, staticRenderFns } from "./vessel_embarkation_hist.vue?vue&type=template&id=b2345dae&scoped=true&"
import script from "./vessel_embarkation_hist.vue?vue&type=script&lang=js&"
export * from "./vessel_embarkation_hist.vue?vue&type=script&lang=js&"
import style0 from "./vessel_embarkation_hist.vue?vue&type=style&index=0&id=b2345dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2345dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b2345dae', component.options)
    } else {
      api.reload('b2345dae', component.options)
    }
    module.hot.accept("./vessel_embarkation_hist.vue?vue&type=template&id=b2345dae&scoped=true&", function () {
      api.rerender('b2345dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/vessel_embarkation_hist.vue"
export default component.exports